/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.MemberBenefitTemplates {
    angular.module("meevo.plugins.memberBenefitTemplates", []);
}